export { default as Status } from './status'



// WEBPACK FOOTER //
// ./src/components/header/status/index.js